type IconProps = React.ComponentProps<'svg'>

export function ArrowLeftIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(4.25, 4.25)">
        <path
          d="M7.21967 0.21967C7.51256 -0.0732233 7.98732 -0.0732233 8.28022 0.21967C8.57305 0.512568 8.57309 0.987342 8.28022 1.28022L2.56049 6.99994H14.7499C15.1641 6.99997 15.4999 7.33575 15.4999 7.74994C15.4999 8.16411 15.1641 8.49991 14.7499 8.49994H2.56049L8.28022 14.2197C8.57305 14.5126 8.57309 14.9873 8.28022 15.2802C7.98734 15.5731 7.51257 15.5731 7.21967 15.2802L0.21967 8.28022C-0.0732233 7.98732 -0.0732233 7.51256 0.21967 7.21967L7.21967 0.21967Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
